import { render, staticRenderFns } from "./companyIntroduce.vue?vue&type=template&id=5a864b74&scoped=true"
import script from "./companyIntroduce.vue?vue&type=script&lang=js"
export * from "./companyIntroduce.vue?vue&type=script&lang=js"
import style0 from "./companyIntroduce.vue?vue&type=style&index=0&id=5a864b74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a864b74",
  null
  
)

export default component.exports